/* eslint-disable import/named */
import { call, put, takeEvery, select } from "redux-saga/effects";
// import { Redirect as AppRedirect } from "@shopify/app-bridge/actions";
import * as types from "../../constants";

import * as Services from "./service";

const storeReducer = (state) => state.get("storeReducer");

//  campaign setting email
function* getStoreInfomation() {
  try {
    const response = yield call(Services.getStoreInfomation);
    console.log("response", response);
    yield put({ type: "GET_STORE_INFOMATION_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "GET_STORE_INFOMATION_RESPONSE", error });
  }
}

function* saveStoreInfomation() {
  const storeReducerData = yield select(storeReducer);
  try {
    const response = yield call(
      Services.saveStoreInfomation,
      storeReducerData.get("storeInfomation"),
    );
    yield put({ type: "SAVE_STORE_INFOMATION_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "SAVE_STORE_INFOMATION_RESPONSE", error });
  }
}

function* getCurrentPackage() {
  try {
    const response = yield call(Services.getCurrentPackage);

    yield put({ type: types.GET_CURRENT_PACKAGE_RESPONSE, data: response });
  } catch (error) {
    yield put({ type: types.GET_CURRENT_PACKAGE_RESPONSE, error });
  }
}

function* downgradePackage(action) {
  try {
    const response = yield call(Services.changePlanPackage, action);
    yield put({ type: types.RESPONSE_DOWNGRADE_PACKAGE, data: response });
  } catch (error) {
    yield put({ type: types.RESPONSE_DOWNGRADE_PACKAGE, error });
  }
}

function* upgradePackage(action) {
  try {
    const response = yield call(Services.changePlanPackage, action);
    if (action.price_name === "FREE") {
      yield put({ type: types.RESPONSE_UPGRADE_PACKAGE, data: response });
    } else if (response && response.confirmation_url) {
      window.location.href = response.confirmation_url;
    } else {
      window.location.href = "";
    }
  } catch (error) {
    yield put({ type: types.RESPONSE_UPGRADE_PACKAGE, error });
  }
}
function* checkVerifySenderEmail(action) {
  try {
    const response = yield call(Services.verifySenderEmail, action);
    if (response) {
      yield put({
        type: "SHOW_MODAL_VERIFY_SENDER_EMAIL",
        data: response.success,
      });
    }
  } catch (error) {
    yield put({
      type: "SHOW_MODAL_VERIFY_SENDER_EMAIL",
      data: false,
    });
  }
}
function* sendEmailVerifySender(action) {
  try {
    const response = yield call(Services.sendEmailverifySenderEmail, action);
    if (response) {
      yield put({ type: "SEND_EMAIL_VERIFY_SUCCESS", data: true });
    }
  } catch (error) {
    yield put({ type: "SEND_EMAIL_VERIFY_SUCCESS", data: false });
  }
}
function* storeInfoActions() {
  // yield takeEvery(types.SAVER_SETTINGS_CAMPAIGN, saveSettingsCampaignSaga);
  // yield takeEvery(types.GET_LIST_CAMPAIGN, getListCampaignSaga);
  // yield takeEvery(types.DELETE_CAMPAIGN_SETTINGS, deleteCampaignSaga);
  yield takeEvery(types.DOWNGRADE_PACKAGE, downgradePackage);
  yield takeEvery(types.UPGRADE_PACKAGE, upgradePackage);
  yield takeEvery(types.GET_CURRENT_PACKAGE, getCurrentPackage);
  yield takeEvery(types.GET_STORE_INFOMATION, getStoreInfomation);
  yield takeEvery(types.SAVE_STORE_INFOMATION, saveStoreInfomation);
  yield takeEvery("CHECK_VERIFY_SENDER_EMAIL", checkVerifySenderEmail);
  yield takeEvery("SEND_VERIFY_EMAIL", sendEmailVerifySender);
}

export default storeInfoActions;
